module.exports = __webpack_public_path__ + "IR.png?39d2ed9dd3d5ea0feb1258a0982006a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/IR.png
// module id = 363
// module chunks = 0